import {
    getDataModelProp,
} from "~/stateGetter";

export default function resetItem(state, model, values,) {
    let { modelId } = model;


    let initialModel = getDataModelProp(state, modelId, 'stateModel');

    return {
        ...model,
        item: {
            ...initialModel.item,
            values: values ?? initialModel.item.values,
            id: model.item.id
        },
        itemData: initialModel.itemData
    }
}